import { getLanguage, useLanguage } from "@languages/index"
import Button from "components/button"
import TextInputField from "components/textInput"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { useNavigate } from "react-router-dom"
import { mapDispatchProps, mapStateToProps } from "store/store"
import SeedingWithCommissionsAlert, { TYPES } from "../campaigns/alert/seedingWithCommissionsAlert"
import { Modal } from "antd"
import API from "api"
import dayjs from "dayjs"
import { LOCALES } from "constants/locales"

interface TSeedingWithCommissionsPanel {
  showAlert?: any
  hideBlockButton?: any
  brand?: any
  showOverlays?: any
  type?: any
  title?: any
  onHide?: any
  isPanelVisible?: any
  setPreferences?: any
  preferences?: any
}

const SeedingWithCommissionsPanel = (props: TSeedingWithCommissionsPanel) => {
  const navigate = useNavigate()
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.component.seedingWithCommissionsAlert }

  const bannerImage =
    getLanguage() === LOCALES.JA
      ? "assets/images/commissions/commissions-banner-01-ja.png"
      : "assets/images/commissions/commissions-banner-01.png"

  const [isPanelVisible, setIsPanelVisible] = useState(false)

  useEffect(() => {
    if (props.isPanelVisible != isPanelVisible) {
      setIsPanelVisible(props.isPanelVisible)
    }
  }, [props.isPanelVisible])

  useEffect(() => {
    if (props.showAlert) {
      showAlert()
    }
  }, [props.showAlert])

  const getPanelType = () => {
    switch (props.type) {
      default:
      case TYPES.DEFAULT:
        return "Default"
      case TYPES.T_SHIRTS:
        return "TShirts"
      case TYPES.UNDERWAER:
        return "Underwear"
      case TYPES.REELS:
        return "Reels"
    }
  }

  const isBlocked = (type) => {
    const blockedAt = props.preferences[`seedingWithCommissionsType${type}BlockedAt`]
    if (!blockedAt) return false
    const now = dayjs()
    const unblockTime = dayjs(blockedAt).add(7, "day")
    return now.isBefore(unblockTime)
  }

  const blockAlertForType = (type) => {
    props.setPreferences({ [`seedingWithCommissionsType${type}BlockedAt`]: dayjs().toISOString() })
  }

  const showAlert = (config?: any) => {
    if (!config?.forceOpen) {
      const blockType = getPanelType()
      if (blockType && isBlocked(blockType)) {
        return
      }
    }

    props.showOverlays({
      zIndex: 1081,
      content: () => {
        return (
          <SeedingWithCommissionsAlert
            {...props}
            type={props.type}
            title={props.title}
            onSubmit={() => {}}
            onBlock={() => {
              blockAlertForType(getPanelType())
            }}
            hideBlockButton={props.hideBlockButton}
          />
        )
      },
    })
  }

  return (
    <>
      {isPanelVisible == false ? null : (
        <>
          <div className="flex flex-col w-full mb-[30px]">
            <img
              className="w-full h-full cursor-pointer"
              src={bannerImage}
              onClick={() => {
                showAlert({ forceOpen: true })
              }}
            />
          </div>
        </>
      )}
    </>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(SeedingWithCommissionsPanel)
